import { CustomerOrderDto } from 'common/api/autogenerated/trading-gateway';

import { UpdatedOrder } from './orders.actions';

export const mapSpotOrderUpdateFromSocket = (stateOrders: CustomerOrderDto[] = [], update: UpdatedOrder = {}) =>
  stateOrders.reduce<CustomerOrderDto[]>((result, curr) => {
    if (curr.id === update.orderId) return [...result, { ...curr, amount: update.amount }];

    return [...result, curr];
  }, []);
